module.exports = __webpack_public_path__ + "static/media/cogwheels.81805ca7.svg";